import { render, staticRenderFns } from "./VvHero.vue?vue&type=template&id=145e3355&scoped=true&"
import script from "./VvHero.vue?vue&type=script&lang=js&"
export * from "./VvHero.vue?vue&type=script&lang=js&"
import style0 from "./VvHero.vue?vue&type=style&index=0&id=145e3355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e3355",
  null
  
)

export default component.exports